export enum ReportOption {
  InappropriateMessages,
  InappropriatePhotos,
  Spam,
  Minor,
  Other
}

export namespace ReportOption {
  export function toString(option: ReportOption) {
    switch (option) {
      case ReportOption.InappropriateMessages:
        return 'Messages inappropriés'
      case ReportOption.InappropriatePhotos:
        return 'Photos inappropriées'
      case ReportOption.Spam:
        return 'Spam'
      case ReportOption.Minor:
        return 'Mineur'
      case ReportOption.Other:
        return 'Autre'
    }
  }

  export function names() {
    return Object.keys(ReportOption)
      .map((k: any) => ReportOption[k])
      .filter((v: any) => typeof v === 'string')
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/shared/report-option.enum.ts